import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/utils/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ children, className, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'card_holder rounded-lg border border-[var(--user-border)] p-6 shadow-sm',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className, ...props }: CardProps) {
  return (
    <div className={cn('mb-6 flex flex-col gap-2', className)} {...props}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className, ...props }: CardProps) {
  return (
    <h1 className={cn('text-2xl font-semibold tracking-tight', className)} {...props}>
      {children}
    </h1>
  );
}

export function CardDescription({ children, className, ...props }: CardProps) {
  return (
    <p className={cn('text-sm text-[var(--color-muted)]', className)} {...props}>
      {children}
    </p>
  );
}
